// Get stripped data
export function strippedData(content) {
  // Check if stripped data is empty
  var node = document.createElement("div");
  node.innerHTML = content ? content : "";
  var text = node.innerText;

  return text;
}
